export default __webpack_public_path__ + "static/media/sneakers-authenticate.74dc48f6.svg";